import { render, staticRenderFns } from "./SASCard.vue?vue&type=template&id=6cf83940&scoped=true&"
import script from "./SASCard.vue?vue&type=script&lang=js&"
export * from "./SASCard.vue?vue&type=script&lang=js&"
import style0 from "./SASCard.vue?vue&type=style&index=0&id=6cf83940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf83940",
  null
  
)

export default component.exports